import { Injectable } from "@angular/core";
import { SimpleObservableErrorContext } from "@core/dataiku-api/api-error";

@Injectable()
export class ErrorContextService extends SimpleObservableErrorContext {
}
